<template>
  <div>
    <Card class="card" title="报名单位信息" dis-hover>
      <Form :model="form" :rules="validation" ref="form" class="form" :label-width="136">
        <FormItem :label="`${msg.lib_id}：`" prop="lib_id">
          <Select
            v-model="form.lib_id"
            filterable
            remote
            :remote-method="selfOrgList"
            :placeholder="`请输入学校名称`"
            ref="select"
            :loading="isSelectLoading"
          >
            <Option v-for="option in options" :value="option.university_id" :key="option.university_id">{{option.name}}</Option>
          </Select>
        </FormItem>
        <p style="width: 60%; margin-bottom: 30px; margin-top: -10px;">若未找到所在机构，请将机构名称和地址通过邮箱发送至 13512994150@163.com  后于下一个工作日再次注册</p>
        <FormItem :label="`${msg.name}：`" prop="name">
          <Input :placeholder="`请输入${msg.name}`" :maxlength="10" v-model="form.name" clearable/>
        </FormItem>
        <FormItem :label="`${msg.mobile}：`" prop="mobile">
          <Input :placeholder="`请输入${msg.mobile}`" v-model="form.mobile" clearable/>
        </FormItem>
        <FormItem :label="`${msg.code}：`" prop="code">
          <Input :placeholder="`请输入${msg.code}`" v-model="form.code">
            <span slot="append" @click="send" style="cursor: pointer">{{ codeText }}</span>
          </Input>
        </FormItem>
        <FormItem :label="`${msg.department}：`" prop="department">
          <Input :placeholder="`例：图书馆阅读推广部`" v-model="form.department" clearable/>
        </FormItem>
        <FormItem :label="`${msg.position}：`" prop="position">
          <Input :placeholder="`请输入${msg.position}`" v-model="form.position" clearable/>
        </FormItem>
        <FormItem :label="`${msg.phone}：`" prop="phone">
          <Input :placeholder="`请输入${msg.phone} ${phoneText}`" v-model="form.phone" clearable/>
        </FormItem>
        <FormItem :label="`${msg.email}：`" prop="email">
          <Input :placeholder="`请准确填写，用于接收技术平台链接等`" v-model="form.email" clearable/>
        </FormItem>
        <FormItem :label="`${msg.address}：`" prop="address">
          <Input :placeholder="`请准确填写收件地址、收件人姓名、电话号码，用于寄送证书等资料。`" v-model="form.address" clearable type="textarea" :autosize="{ minRows: 2, maxRows: 2 }"/>
        </FormItem>
        <Button type="primary" size="large" @click="submit" style="margin-top: 1rem">提交</Button>
      </Form>
    </Card>
  </div>
</template>
<script>
import { Card, Form, FormItem, Select, Input, Option } from "view-design"
import { getOrgList, getCode, register } from "@/api/getApi"
import { setCookie } from "@/js/public"
import { mapState } from "vuex";
export default {
  name: 'Register',
  components: {
    Card, Form, FormItem, Select, Input, Option
  },
  data () {
    return {
      form: {
        name: '',
        lib_type: '',
        lib_id: '',
        phone: '',
        mobile: '',
        department: '',
        position: '',
        code: '',
        email: '',
        address: ''
      },
      phoneText: '(区号—电话号码)',
      msg: {
        lib_id: '机构名称',
        name: '管理员姓名',
        mobile: '管理员手机号',
        code: '验证码',
        department: '所属部门',
        position: '职务',
        phone: '座机号码',
        address: '收件地址',
        email: '电子邮箱'
      },
      validation: {
        name: [{ required: true, message: `请输入管理员姓名`, trigger: 'blur' }],
        lib_type: [{ type: 'number', required: true, message: `请选择`, trigger: 'blur' }],
        lib_id: [{ type: 'number', required: true, message: `请输入机构名称`, trigger: 'blur' }],
        phone: [{ required: true, message: `请输入座机号码`, trigger: 'blur' },
          /* eslint-disable-next-line */
          { pattern: /^0?\d{2,3}\-\d{7,8}$/, message: `请输入正确的座机号码`, trigger: 'blur' }],
        mobile: [{ required: true, message: `请输入管理员手机号`, trigger: 'blur' },
          { pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/, message: `请输入正确的管理员手机号`, trigger: 'blur' }],
        department: [{ required: true, message: `请输入所属部门`, trigger: 'blur' }],
        position: [{ required: true, message: `请输入职务`, trigger: 'blur' }],
        code: [{ required: true, message: `请输入验证码`, trigger: 'blur' }],
        email: [{ required: true, message: `请输入电子邮箱`, trigger: 'blur' },
          { pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/, message: `请输入正确的电子邮箱`, trigger: 'blur' }],
        address: [{ required: true, message: `请输入收件地址`, trigger: 'blur' }]
      },
      orgData: [],
      options: [],
      text: '发送验证码',
      time: 60,
      isClick: true,
      timer: '',
      codeText: '发送验证码',
      userLevel: '',
      isSelectLoading: false
    }
  },
  computed: {
    ...mapState({
      entrance: state => state.entrance
    })
  },
  methods: {
    submit () {
      const params = {
        university_id: this.form.lib_id,
        name: this.form.name,
        mobile: this.form.mobile,
        telephone: this.form.phone,
        code: this.form.code,
        position: this.form.position,
        department: this.form.department,
        email: this.form.email,
        address: this.form.address
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          register(params).then(res => {
            if (res.code !== 200) {
              this.$Message.error(res.message)
              return
            }
            const token = res.data.access_token
            setCookie('readStar', token)
            setCookie('level', 0)
            setCookie('id', this.form.lib_id)
            this.$router.replace(`/admin/userInfo?id=${this.form.lib_id}`)
          }).catch(e => {
            this.$Message.error(e)
          })
        }
      })
    },
    async getSchoolList () {
      try {
        const res = await getOrgList()
        this.orgData = res.data || []
        this.selfOrgList(this.form.lib_id)
      } catch (e) {
        this.$Message.error(e)
      }
    },
    selfOrgList (str) {
      this.isSelectLoading = true
      this.options = this.orgData.filter((val) => {
        if (val.name.includes(str) || `${val.id}`.includes(`${str}`)) {
          return val
        }
      })
      this.isSelectLoading = false
    },
    send () {
      if (!this.isClick) {
        return false;
      }
      this.$refs.form.validateField('mobile', (valid) => {
        if (valid) {
          return false;
        }
        this.timer = setInterval(() => {
          this.isClick = false;
          this.time--;
          this.codeText = this.time + '秒';
          if (this.time === 0) {
            this.clearTimer();
          }
        }, 1000);
        this.sendMsg();
      });
    },
    async sendMsg () {
      const res = await getCode({ mobile: this.form.mobile, scene: 0 })
      if (res.code !== 200) {
        this.$Message.error(res.message)
        this.clearTimer();
        return
      }
      this.$Message.success(`验证码已发送`)
    },
    clearTimer () {
      clearInterval(this.timer);
      this.codeText = this.text;
      this.time = 60;
      this.isClick = true;
    }
  },
  mounted () {
    this.getSchoolList()
  }
}
</script>
<style lang="scss" scoped>
.card {
  position: relative;
  z-index: 3;
  min-width: 40rem;
  min-height: 60rem;
  max-width: 70rem;
  margin: 2rem auto;
  ::v-deep .ivu-input-wrapper, ::v-deep .ivu-select {
    width: 26rem;
  }
  ::v-deep .ivu-card-head p, ::v-deep .ivu-card-head-inner {
    font-size: 1.8rem;
    font-weight: bold;
  }
  .form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    ::v-deep .ivu-form-item-label {
      text-align: left;
      font-size: 1.6rem;
    }
  }
}
</style>
